<template>
  <el-dialog
    width="70%"
    title="Информация для формирования счета"
    class="dialog--save-nomenclature--without-scan"
    :before-close="() => $emit('closeDialog')"
    :visible.sync="visible"
    append-to-body
  >
    <el-form ref="form" label-width="250px" label-position="top">
      <el-form-item label="">
        <select-remote
          placeholder-text="Пожалуйста ввидите название организации"
          @selectValue="selectOrganization"
        />
      </el-form-item>
      <el-form-item>
        <date-picker @pickedDate="pickedDate" />
      </el-form-item>
      <el-row>
        <el-col :span="5">
          <el-form-item label="Что выгружать:">
            <el-checkbox-group v-model="checkedScoupe">
              <el-checkbox
                v-for="(value, index) in formData.scopes"
                :key="index"
                :label="index"
              >
                {{ value }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <div class="watermarks-list--checkbox">
            <div class="item">
              <el-form-item
                v-show="checkedScoupe.find(scoupe => scoupe === 'acts')"
                label="С печатью копия верна?"
                class="select--watermark"
              >
                <el-select
                  v-model="checkedWatermarks.acts"
                  placeholder="Выберите из списка"
                  size="mini"
                  clearable
                  style="width: 170px"
                >
                  <el-option
                    v-for="item in formData.watermarks.acts"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </div>

            <div class="item">
              <el-form-item
                v-show="checkedScoupe.find(scoupe => scoupe === 'ttns')"
                label="С печатью копия верна?"
                class="select--watermark"
              >
                <el-select
                  v-model="checkedWatermarks.ttns"
                  placeholder="Выберите из списка"
                  size="mini"
                  clearable
                  style="width: 170px"
                >
                  <el-option
                    v-for="item in formData.watermarks.ttns"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="watermarks-list--checkbox">
            <div
              v-for="(value, index) in formData.combine"
              :key="index"
              class="item mod-combine"
            >
              <el-form-item
                v-show="checkedScoupe.find(scoupe => scoupe === index)"
                label="Комбайн?"
                class="select--watermark"
              >
                <el-select
                  v-model="checkedCombine[index]"
                  placeholder="Выберите из списка"
                  size="mini"
                  clearable
                  style="width: 170px"
                >
                  <el-option
                    v-for="item in formData.combine[index]"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <div>
        <el-button
          type="primary"
          :disabled="progressBar.is"
          @click="onSaveNomenclatureHandler"
        >
          Сформировать
        </el-button>
      </div>
      <div v-if="progressBar.start" class="progress-bar--container">
        <div class="progress-bar--text">
          Скачивание начнется автоматически сразу после формирования отчета на
          сервере.

          <div v-if="statusDownload === 'ready'">
            <span class="bold">
              Отчет сформирован. Если скачивание не началось автоматически.
              Перейдите по ссылке.
            </span>
            <a target="_blank" :href="linkDownload">{{ linkDownload }}</a>
          </div>
          <div v-if="statusDownload !== 'ready'">
            Если файл не смог сформироваться полностью, нажмите эту
            <el-link
              class="reload-link"
              type="danger"
              @click.native="reloadDownloadReport"
            >
              ссылку
            </el-link>
            для переформироваться
          </div>
        </div>

        <progress-bar
          v-if="progressBar.is"
          color="#67C23A"
          :time="10000"
          :start="true"
        />
      </div>
    </div>
  </el-dialog>
</template>

<script>
import DatePicker from '@/components/Forms/FormSaveNomenclatureByProviderAndDate/components/DatePicker'
import SelectRemote from '@/components/Forms/FormSaveNomenclatureByProviderAndDate/components/SelectRemote'
import index from '@/components/Forms/FormSaveNomenclature/mixins'
import moment from 'moment'

export default {
  name: 'FormSaveNomenclatureByProviderAndDate',
  components: { DatePicker, SelectRemote },
  mixins: [index],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: {
        selectOrganization: null,
        dateStart: null,
        dateEnd: null,
      },
    }
  },
  methods: {
    pickedDate(newVal) {
      this.formData.dateStart = newVal[0]
      this.formData.dateEnd = newVal[1]
      this.$emit(
        'pickedDate',
        moment(this.formData.dateStart).format('YYYY-MM-DD'),
        moment(this.formData.dateEnd).format('YYYY-MM-DD'),
      )
    },
    selectOrganization(newVal) {
      this.formData.selectOrganization = newVal
      this.$emit('selectOrganization', newVal)
    },
  },
}
</script>

<style lang="sass" scoped>
.mod-combine
  margin-bottom: 5px
</style>
